import React, { useEffect, useState } from "react";
import Input from "../modules/Input";
import Button from "../modules/Button";
import { GetBaseUrl } from "../modules/getBaseUrl";
import { useDispatch, useSelector } from "react-redux";
import { addCandidateInfo, addCandidatePage } from "./redux/actions";
import { registrationAPI } from "./SampleJson";
import { api } from "../../Services";
import TransitionAlerts from "../modules/Alerts";
import Timer from "../modules/Timer";
import ModalComponent from "../modules/Modal";
import GradientLoader from "../modules/Loader";
import { useNavigate } from "react-router-dom";

function MobileVerification() {
  const [valid, setValid] = useState(false);
  const [otp, setOtp] = useState("");
  const [loader, setLoader] = useState(false);
  const [info, setInfo] = useState({
    mobile: "",
    mOtp: "",
  });
  const navigate = useNavigate();

  const [resData, setResData] = useState([]);

  const [loading, setLoading] = useState(false);
  const [otpCount, setOtpCount] = useState(0);
  const [err, setErr] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [timeRemaining, setTimeRemaining] = useState(30);
  const [alertType, setAlertType] = useState({ msg: "", type: "" });
  const [alert, setAlert] = useState(false);

  const [type, setType] = useState({ type: "number" });
  const dispatch = useDispatch();
  const registeredData = useSelector((state) => state.register.registeredData);

  // const getMaskedPassword = (password) => {
  //   if (props.mask) {
  //     if (value2 !== password) {
  //       setValue2(password);
  //     }
  //     if (showPassword) {
  //       return password;
  //     } else if (props.id !== "aadhar") {
  //       if (password.length <= 3) {
  //         return password;
  //       } else {
  //         if (typeof password === "string") {
  //           return (
  //             password?.slice(0, 3) +
  //             "*".repeat(
  //               password?.length - (password?.length > 6 ? 6 : password?.length)
  //             ) +
  //             password?.slice(-3)
  //           );
  //         }
  //       }
  //     }
  //   }
  // };
  const editText = () => {
    let value = registeredData?.info?.mobile;
    value =
      value?.slice(0, 3) +
      "*".repeat(value?.length - (value?.length > 6 ? 6 : value?.length)) +
      value?.slice(-3);
    return (
      <div className="edit-text">
        <span className="left-edit">We have sent an OTP to {value}</span>
        <span
          onClick={() => {
            setType({ ...type, type: "number" });
            setOtp("");
          }}
          className="pointer right-edit"
        >
          Edit
        </span>
      </div>
    );
  };

  const doSendOtp = async (category) => {
    console.log("category", category);
    setIsLoading(true);
    try {
      let numbercheck = await verifyContent(category);

      if (numbercheck?.status) {
        numbercheck = numbercheck.status;
      }
      if (numbercheck?.data?.metadata?.code == "200") {
        setAlertType({
          ...alertType,
          msg: numbercheck?.data?.metadata?.message,
        });
        setType({ type: "otp" });

        setAlert(true);
        setTimeout(() => setAlert(false), 3000);
        console.log("in 200 mobile", numbercheck);
      }else if(numbercheck.statusCode == 500){
        // setAlertType({
        //   ...alertType,
        //   msg: numbercheck?.data?.metadata?.message,
        // });
        // setAlert(true);
        setErr(numbercheck?.data);
        setTimeout(() => setErr(""), 5000);
      } else {
        // setAlertType({
        //   ...alertType,
        //   msg: numbercheck?.data?.metadata?.message,
        // });
        // setAlert(true);
        setErr(numbercheck?.data?.metadata?.message);
        setTimeout(() => setErr(""), 5000);
      }
    } catch (err) {
      alert(err.data);
      console.log("err", err);
    } finally {
      setIsLoading(false);
    }
  };
  const nextField = async () => {
    try {
      console.log("type.type", type.type);
      if (type.type === "number") {
        let sendOtp = await doSendOtp("number");
        console.log("api", sendOtp);
      } else {
        // if (otpCount < 3) {
        let otpCheck = await verifyContent("otp");
        console.log("otpCheck", otpCheck);

        if (otpCheck?.status) {
          otpCheck = otpCheck.status;
        }
        if (otpCheck?.data?.metadata?.code == "200") {
          setAlertType({
            ...alertType,
            msg: otpCheck?.data?.metadata?.message,
          });
          setAlert(true);
          console.log("in 200 otp", otpCheck);

          let url = GetBaseUrl(window.location.href);
          // window.location.replace(url + "/signup/email");
          navigate("/signup/email");

        } else {
          setAlertType({
            ...alertType,
            msg: otpCheck?.data?.metadata?.message,
          });
          setAlert(true);
        }
        setOtpCount((prev) => prev + 1);
        // } else {
        //   setLoading(true);

        //   setTimeout(() => {
        //     setType({ type: "number" });
        //     setLoading(false);
        //   }, 3000);
        // }
      }
    } catch (err) {
      if(err.data && typeof err.data === 'string' ){

        setErr(err.data);
      } else {
        setErr("Sorry! Something went wrong, Please try again");
      }

      alert(err.data);
    }
    setTimeout(() => setErr(""), 3000);

    setTimeout(() => setAlert(false), 3000);
    // makeRegister();
  };

  const filterInput = (data) => {
    let isError = true;

    if (type.type === "otp") {
      data = data.replace(/\D/g, "");
      if (data?.length > 5) {
        data = data.slice(0, 6);
        isError = false;
      } else if (data?.length < 6) {
        isError = true;
      }
      // if (type.type === "number") {
      //   otp = data;
      // } else {
      //   info1.eOtp = data;
      // }
    } else if (type.type === "number") {
      data = data.replace(/\D/g, "");
      if (data?.length > 9) {
        data = data.slice(0, 10);
        // if (password.length <= 3) {
        //   return password;
        // }
        // data= data.slice(0, 3) + '*'.repeat(data.length - 3);
        isError = false;
      } else if (data?.length < 10) {
        isError = true;
      }
      // info1.mobile = data;
    }

    console.log("is error", isError);
    // setValid(!isError);
    // setInfo({ ...info1 });
    return data;
  };
  const doResendOtp = () => {
    doSendOtp("number");
    setTimeRemaining(30);
  };
  const resendText = () => {
    return (
      <div className="edit-text">
        <span
          className={`left-edit ${timeRemaining > 0 ? "disabled-text" : ""} `}
          onClick={() => doResendOtp()}
        >
          Resend OTP{" "}
        </span>
        {timeRemaining > 0 && (
          <span className="pointer right-edit">
            00:
            {
              <Timer
                limit={30}
                isTime={(e) => setTimeRemaining(e)}
                time={timeRemaining}
              />
            }
          </span>
        )}
      </div>
    );
  };
  const assignData = (data) => {
    console.log("type.type", type.type);
    type.type === "number"
      ? dispatch(addCandidateInfo(["mobile", filterInput(data)]))
      : setOtp(filterInput(data));
  };
  const verifyContent = async (category) => {
    setLoader(true);
    setIsLoading(true);

    try {
      let users;
      if (category === "number") {
        users = await api.getMobileOTP(registeredData?.info?.mobile);
        if (users.statusCode == 200) {
          setResData([
            users.data.resourceData[0]?.linkData,
            users.data.resourceData[0]?.referenceNumber,
          ]);
        }
      } else {
        users = await api.verifyMobileOTP(otp, resData[0], resData[1]);
      }
      //   let url = GetBaseUrl(window.location.href);
      console.log("users", users);
      if (users.statusCode == 500) {
        if(users.data && typeof users.data === 'string' ){

          setErr(users.data);
        }

        setTimeout(() => setErr(""), 3000);
      }
      //   window.location.replace(url);
      setLoader(false);
      return users;
    } catch (error) {
      setLoader(false);

      console.error("Error invoking Aadhaar OTP:", error);
      if (error.statusCode == "403") {
        // alert(error.message)
        setAlertType({
          msg: "Sorry! Something went wrong, Please connect with administrater",
          type: "otp",
        });
        setAlert(true);
        setTimeout(() => setAlert(false), 3000);
      } else if (error.statusCode == "500") {
        // alert(error.message)
        setAlertType({
          msg: "Username already exists",
          type: "otp",
        });
        setAlert(true);
        setTimeout(() => setAlert(false), 3000);
      } else {
        // setAlertType({
        //   msg: "Username already exists",
        //   type: "otp",
        // });
        // setAlert(true);
        alert(error.data);
        // setTimeout(() => setAlert(false), 3000);
      }

      return error;
      // Handle error scenario
    } finally {
      setIsLoading(false);
    }
  };
  const assignDataItem = (e) => {
    assignData(e);
  };
  useEffect(() => {
    // console.log("valid changed", valid);
  }, [registeredData?.info]);
  console.log("register", registeredData, err);
  return (
    <div className="cred-section verification">
      <span className="title">Sign up</span>
      <span className="sub-title">
        {type.type === "otp"
          ? editText()
          : `You will receive an OTP on your mobile`}
      </span>

      <div className="cred-fields">
        <Input
          onChange={(e) => assignDataItem(e)}
          // inputType={type.type === "number" && "rupee"}
          placeholder={
            type.type === "number"
              ? "Mobile Number linked with Aadhaar "
              : "Enter OTP"
          }
          disabled={isLoading}
          value={type.type === "number" ? registeredData.info.mobile : otp}
          // setValid={(e) => setValid(e)}
          // onChange={(e) => setVal(e)}
          // mask={true}

          type={"password"}
          id={"password"}
        />

        {err  && (
          <div
            className="warning-msg"
            style={{ color: "red", textAlign: "left" }}
          >
            {err}
          </div>
        )}
      </div>
      {alertType.msg && (
        <TransitionAlerts isAlert={alert} message={alertType.msg} />
      )}
      <div className="cred-btn">
        <Button
          disabled={
            type.type === "number"
              ? registeredData?.info?.mobile?.length < 10
              : otp?.length < 6
          }
          value={
            isLoading ? (
              <div className="loading-spinner">
                {/* Add your loading spinner component or icon here */}
                <i className="fas fa-spinner fa-spin"></i>
              </div>
            ) : (
              "Next"
            )
          }
          type={"contained"}
          onClickHandler={() => nextField()}
        />
        {type.type === "otp" && (
          <Button
            //   disabled={!value}
            onClickHandler={() => {}}
            value={resendText()}
            type={"only-text"}
            disabled={isLoading}
          />
        )}
      </div>
      {loading && (
        <ModalComponent
          className={"loader-model"}
          show={loading}
          // handleClose={() => CancelData()}
          // title={ModalData.title}
          // content={ModalData.desc}
        >
          <GradientLoader />
        </ModalComponent>
      )}
    </div>
  );
}

export default MobileVerification;
